import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Dashheader from '../Dashheader/Dashheader';
import api from './../../../api.js';
import { useToasts } from "react-toast-notifications";
import Loading from '../../../utilis/Loading.js';
import utilis from '../../../utilis';

const AddTowersStep5 = () => {
  const { addToast } = useToasts();
  const [showExitPopup, setShowExitPopup] = useState(false);
    
      const handleExit = () => {
        setShowExitPopup(false); // Hide the popup
        navigate('/login/dashboard', { replace: true }); // Navigate to the dashboard
      };
      
  const navigate = useNavigate();
  const location = useLocation();
  const { towerId, companyId, projectId  } = location.state || {}; // Receive towerId from previous steps

  useEffect(() => {
    console.log('🚀 Received towerId in Step 5:', towerId,companyId,projectId);
  }, [towerId, companyId, projectId ]);

  const storedData = JSON.parse(localStorage.getItem('AdminDetails')) || {};
  let managementId = storedData?.data?.data?._id || null;

  const [formData, setFormData] = useState({
    title: '',
    description: '',
    abtImage: null,
    createdBy4: managementId,
    step: 5,
    towerId: towerId || '', // Ensure towerId is set
    companyId: companyId,
    projectId: projectId,
  });
  
  const [submittedEntries, setSubmittedEntries] = useState([]); // Store submitted entries
  const [showForm, setShowForm] = useState(true); // Control form visibility

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === 'abtImage') {
      setFormData({ ...formData, abtImage: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  // Add a new entry to the "about" field array
  const handleAdd = () => {
    setFormData({
      ...formData,
      about: [...formData.about, { title: '', description: '' }],
    });
  };

  // Remove an entry from the "about" field array
  const handleRemove = (index) => {
    const updatedAbout = formData.about.filter((_, i) => i !== index);
    setFormData({ ...formData, about: updatedAbout });
  };
  const [errors, setErrors] = useState({});

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage(null);

    try {
      const data = new FormData();
      data.append('createdBy4', formData.createdBy4);
      data.append('step', formData.step);
      data.append('towerId', formData.towerId);
      data.append('companyId', formData.companyId);
      data.append('projectId', formData.projectId);
      data.append('title', formData.title);
      data.append('description', formData.description);
      if (formData.abtImage) {
        data.append('abtImage', formData.abtImage);
      }

      const response = await api.addTowers(data);
      console.log('Step 5 Success:', response.data);
      if(response.status === 401){
        console.log("Session Expired! Redirecting to Login.");
        localStorage.removeItem(utilis.string.localStorage.sessionId);
        localStorage.removeItem(utilis.string.localStorage.userData);
        navigate('/');
      }
      setMessage({ type: 'success', text: 'Step 5 completed successfully!' });

      if (response.status === 200) {
        // Store the submitted entry locally
        setSubmittedEntries(prev => [
          ...prev,
          {
            title: formData.title,
            description: formData.description,
            abtImage: formData.abtImage ? URL.createObjectURL(formData.abtImage) : null
          }
        ]);
        setShowForm(false); // Hide form after submit
        addToast("Step 5 submitted successfully", {
          appearance: "success",
          autoDismiss: true,
        });
        // Do NOT navigate to next page
      } else {
        addToast(response.data?.message || "Something went wrong!", {
          appearance: "error",
          autoDismiss: true,
        });
      }
    } catch (error) {
      setMessage({ type: 'error', text: 'Error submitting Step 5. Please try again.' });
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  const navigateto = () => {
    navigate("/addtowers/step7", { state: { towerId, companyId, projectId } });
  };
  

  const handleAddMore = () => {
    setFormData({
      title: '',
      description: '',
      abtImage: null,
      createdBy4: managementId,
      step: 5,
      towerId: towerId || '',
      companyId: companyId,
      projectId: projectId,
    });
    setShowForm(true);
    setMessage(null);
  };

  return (
    <>
      <Dashheader />
      {loading ? (
            <Loading/>
          ) : (
      <div className="addtowers">
        <h2>Add Project - Step 5</h2>

        {message && <div className={`message ${message.type}`}>{message.text}</div>}

        {/* Show submitted entries */}
        {submittedEntries.length > 0 && (
          <div className="submitted-entries" style={{marginBottom: '20px'}}>
            <h3>Submitted Details</h3>
            {submittedEntries.map((entry, idx) => (
              <div key={idx} style={{border: '1px solid #ccc', padding: '10px', marginBottom: '10px'}}>
                <strong>Title:</strong> {entry.title}<br/>
                <strong>Description:</strong> {entry.description}<br/>
                {entry.abtImage && (
                  <div><strong>Image:</strong><br/><img src={entry.abtImage} alt="abtImage" style={{maxWidth: '200px', marginTop: '5px'}} /></div>
                )}
              </div>
            ))}
          </div>
        )}

        {/* Show form only if showForm is true */}
        {showForm && (
          <form onSubmit={handleSubmit} className="addtowers-form">
            <div className="about-field" style={{ padding: '15px', marginBottom: '10px', border: '1px solid #ddd', borderRadius: '5px' }}>
                <input
                  type="text"
                  name="title"
                  placeholder="About Tower Title*"
                  value={formData.title}
                  onChange={handleChange}
                  required
                  style={{ padding: '10px', width: '100%', marginBottom: '10px' }}
                />
                <textarea
                  name="description"
                  placeholder="About Tower Description*"
                  value={formData.description}
                  onChange={handleChange}
                  required
                  style={{ padding: '10px', width: '100%', marginBottom: '10px' }}
                />
                <input
                  type="file"
                  name="abtImage"
                  onChange={handleChange}
                  style={{ marginBottom: '10px' }}
                />
              </div>
            <input type="hidden" name="createdBy4" value={formData.createdBy4} />
            <input type="hidden" name="step" value={formData.step} />
            <input type="hidden" name="towerId" value={formData.towerId} />
            <button type="submit" disabled={loading}>
              {loading ? 'Submitting...' : 'Save'}
            </button>
            <button
              type="button"
              onClick={() => setShowExitPopup(true)}
              className="exit-button"
            >
              Exit
            </button>
            {showExitPopup && (
              <div className="exit-popup">
                <p>Are you sure you want to exit without saving?</p>
                <button onClick={handleExit}>Yes</button>
                <button onClick={() => setShowExitPopup(false)}>No</button>
              </div>
            )}
          </form>
        )}

        {/* Show Add More button if form is hidden (after submit) */}
        {!showForm && (
          <button onClick={handleAddMore} style={{marginTop: '10px'}} className="exit-button">Add More</button>

        )}
         
              <button onClick={navigateto} className="submit-btn" style={{marginLeft:"10px",marginTop:"20px"}}>Navigate to step6</button>
            
      </div>
       )}
    </>
  );
};

export default AddTowersStep5;
